import { Layout, Text } from '@loadsmart/miranda-react'

import { type Stop, hasDate } from 'core/domain/Stop'
import {
  formatDateAndTime,
  formatLocation,
  formatFacilityName,
} from 'core/presenters/stopPresenter'

export type LoadStopAddressProps = {
  stop: Stop
}

export function LoadStopAddress({ stop }: LoadStopAddressProps) {
  return (
    <Layout.Stack gap="spacing-0-5">
      <Text>{formatFacilityName(stop)}</Text>
      <Text variant="heading-md-bold">{formatLocation(stop)}</Text>
      {hasDate(stop) && <Text>{formatDateAndTime(stop)}</Text>}
    </Layout.Stack>
  )
}
